import { Box, Select, Typography } from "@bca/ui-library";
import React from "react";
import SortOption from "../Interfaces/SortOption";

import SortLoader from "./SortLoader";

interface SortProps {
  isLoading: boolean;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  sortOptions: SortOption[];
  selectedSortOption: string;
}

const Sort: React.FunctionComponent<SortProps> = ({
  isLoading,
  onChange,
  sortOptions,
  selectedSortOption,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      width="100%"
      justifyContent="flex-end"
      paddingBottom={{
        mobile: "0",
        tablet: "0",
        desktop: "48px",
      }}
    >
      {!isLoading && (
        <Box
          display="flex"
          flexDirection="row"
          width="270px"
          justifyContent="space-between"
          alignSelf="center"
          alignItems="center"
        >
          <Typography fontWeight="bold">Sort by</Typography>
          <Select
            id="sortOptions"
            label=""
            marginX={0}
            marginY={0}
            onChange={onChange}
            value={selectedSortOption}
            width="200px"
            css="font-size:14px; box-shadow: none;"
          >
            {sortOptions.map((sortOption: SortOption) => (
              <option key={sortOption.key} value={sortOption.key}>
                {sortOption.label}
              </option>
            ))}
          </Select>
        </Box>
      )}
      {isLoading && <SortLoader />}
    </Box>
  );
};

export default Sort;
